<template lang="pug">
  .tilt-card
    .shadow
    //.notify(v-if="notify")
      img(src="~assets/notify.png")      
    .tilt(ref="tilt")
      .card(ref="card" :class="active? 'active':''" @click="onClick" @mousedown="onmousedown" @mouseup="onmouseup")
        img(:src="img")
      .notify_event(v-if="notify_event") 温馨提示：<br>上海回来了，我们也回来了！支付宝空间站已恢复营业。为营造健康的体验环境，请您配合现场防疫工作，提前预约、扫描场所码并展示72小时核酸阴性证明、全程佩戴口罩。<br>寒冬已过，让我们一起迎接一个灿烂的夏天！  
      // .notify_event(v-if="notify_event") 亲爱的朋友们，小布同学温馨提示：<br/>7月30日、31日两天的9:30-11:30，我们在互动区安排了一场寓教于乐的公益亲子活动，欢迎大家前来围观呀！当日11点半之后恢复“拯救消失的能量”展项体验，感谢您的理解与支持！
      .copy
        .cn 惊喜盲盒 <br/>&<br/> 我的足迹
        .en {{copy.en}}
</template>

<script>
import { mapState } from 'vuex'
import VanillaTilt from 'src/libs/vanilla-tilt'
export default {
  name: 'TiltCard',
  props: {
    img: {},
    copy: {},
    // notify: {
    //   default: false,
    // },
    // resed: {
    //   default: false,
    // },
    notify_event: {
      default: false
    }
  },
  data() {
    return {
      active: false,
    }
  },
  computed: {
    ...mapState('app', ['appStatus']),
  },
  mounted() {
    //Gyro.on(Gyro.Events.UPDATE, this._onGyroUpdate)
    VanillaTilt.init(this.$refs.tilt, {
      max: 10,
      speed: 400,
      //glare: true,
    })
  },
  methods: {
    onClick() {
      //this.active = true
      this.$emit('clicked')
    },
    // _onGyroUpdate(evt) {
    //   console.log(evt)
    // },
    onmousedown() {
      this.active = true
    },
    onmouseup() {
      this.active = false
    },
  },
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.tilt-card
  width: 100%
  height: 100%
  .notify
    width: pxToRem(670*1.1)
    height: pxToRem(82*1.1)
    top: pxToRem(-120)
    left: 0
    position: absolute
    img
      margin-left: pxToRem(-50)
      width: 100%
      height: 100%
      object-fit: contain
  .tilt
    -webkit-touch-callout: none
    position: relative
    width: 100%
    height: 100%
    border-radius: pxToRem(16)
    transform-style: preserve-3d
    box-shadow: 0 pxToRem(20) pxToRem(60) pxToRem(-10) rgba(59, 74, 92, 0.7), 0 pxToRem(40) pxToRem(90) 0 rgba(22, 139, 255, 0.2), pxToRem(2) pxToRem(10) pxToRem(25) pxToRem(-10) rgba(22, 139, 255, 0.5)
    //-webkit-mask-image: -webkit-radial-gradient(white, black);
    .card
      width: 100%
      height: 100%
      overflow: hidden
      transform-origin: center
      transition: transform 0.1s $easeOutCubic
      border-radius: pxToRem(16)
      //box-shadow: 0 20px 70px -10px rgba(51, 51, 51, 0.7), 0 50px 100px 0 rgba(51, 51, 51, 0.2)
      -webkit-mask-image: -webkit-radial-gradient(white, black)
      -webkit-touch-callout: none

      img
        -webkit-touch-callout: none
        transition: transform 0.1s $easeOutCubic
        transform-origin: center
        position: relative
        left: -2.5%
        top: -2.5%
        width: 105%
        height: 105%
      &.active
        transition: transform 0.2s cubic-bezier(0.075, 0.02, 0.165, 1)
        transform: scale(1.03)
        img
          transition: transform 0.2s cubic-bezier(0.075, 0.02, 0.165, 1)
          transform: scale(0.955)
    .copy
      pointer-events: none
      color: #fff
      position: absolute
      left: pxToRem(35)
      bottom: pxToRem(31)
      transform: translateZ(20px)
      .cn
        font-size: 20px
        font-family: $ff-number-big
        text-shadow: 0 2px 1.7px rgba(11, 4, 7, 0.2)
      .en
        margin-top: 0
        font-size: 12px
        font-family: $ff-number-big
        padding-left: 1px
        font-weight: 300
        text-shadow: 0 2px 1.7px rgba(11, 4, 7, 0.2)  
    .notify_event
      position: absolute
      color: white
      left: pxToRem(35)
      top: pxToRem(31)
      font-size: pxToRem(28)
      text-shadow: 0 2px 1.7px rgba(11, 4, 7, 0.2)  
</style>
